import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AnalyticsPage from './pages/AnalyticsPage';
import PortalShell from './components/PortalShell';
import ProtectedRoute from './components/ProtectedRoute';
import { PortalProvider } from './context/PortalContext';
import ClubsPage from './pages/ClubsPage';
import CounterPage from './pages/CounterPage';
import DashboardPage from './pages/DashboardPage';
import FinancePage from './pages/FinancePage';
import FinancePlayerTrailPage from './pages/FinancePlayerTrailPage';
import HistoryPage from './pages/HistoryPage';
import LoginPage from './pages/LoginPage';
import MembersPage from './pages/MembersPage';
import NotFoundPage from './pages/NotFoundPage';
import SettingsPage from './pages/SettingsPage';
import SubscriptionPage from './pages/SubscriptionPage';
import TableDetailPage from './pages/TableDetailPage';
import TableLiveViewPage from './pages/TableLiveViewPage';
import TablesPage from './pages/TablesPage';

const App: React.FC = () => {
  return (
    <PortalProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <PortalShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="clubs" element={<ClubsPage />} />
          <Route path="mesas" element={<TablesPage />} />
          <Route path="mesas/:tableId" element={<TableDetailPage />} />
          <Route path="membros" element={<MembersPage />} />
          <Route path="contador" element={<CounterPage />} />
          <Route path="historico" element={<HistoryPage />} />
          <Route path="financeiro" element={<FinancePage />} />
          <Route path="financeiro/jogadores/:userId" element={<FinancePlayerTrailPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="rake" element={<Navigate to="/analytics" replace />} />
          <Route path="relatorios" element={<Navigate to="/analytics" replace />} />
          <Route path="assinatura" element={<SubscriptionPage />} />
          <Route path="configuracoes" element={<SettingsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route
          path="/mesas/:tableId/ao-vivo"
          element={
            <ProtectedRoute>
              <TableLiveViewPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </PortalProvider>
  );
};

export default App;
